// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AutoSubmitController from './auto_submit_controller'
application.register('auto-submit', AutoSubmitController)

import BulkUploadController from './bulk_upload_controller'
application.register('bulk-upload', BulkUploadController)

import FileAttachmentsController from './file_attachments_controller'
application.register('file-attachments', FileAttachmentsController)

import HelloController from './hello_controller'
application.register('hello', HelloController)

import ImageAnalyzerController from './image_analyzer_controller'
application.register('image-analyzer', ImageAnalyzerController)

import SearchController from './search_controller'
application.register('search', SearchController)

import TagSelectorController from './tag_selector_controller'
application.register('tag-selector', TagSelectorController)
